import React, { Fragment, Component } from "react";
import './ExceptionReturn.css'

class ExceptionReturn extends Component {
    constructor(props) {
        super(props);
        this.state = {
          metricTitle: this.props.metricTitle,
          exceptionNumber: this.props.exceptionNumber
        };
      }

      returnError() { switch (this.props.exceptionNumber) {
        case 998:
          return (
            'Not Applicable before 2014-2015'
          );
            case 997:
            return (
              'Insufficient Sample'
            );
              case 996:
              return (
                'Not Applicable'
              );
                case 995:
                return (
                  'Insufficient Data'
                );
                  case 994:
                  return (
                    'Data Not Available'
                  );
                    case 992:
                    return (                      
                        'Data Not Valid'
                    );
                    default: }}; 

  render() {
    
    return (
      <Fragment>

        <span style={{color:'white'}}> {this.returnError()}</span> 
        
        {this.props.disable?null:<span>You have excluded this metric.</span>}
      
      </Fragment>
        );
  }}

export default ExceptionReturn;
